import { useNavigationContext } from '../../../contexts/NavigationContext';
import MainLayout from '../../../components/Display/MainLayout';
import CircumstancePage from './Circumstance/CircumstancePage';
import ProjectPage from './Project/ProjectPage';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <MainLayout scope={'prna'} websiteLabel={"potiron-architectes.fr"}>
      <ProjectPage isActive={navigationContext.activeAppKey === 'prnaproject'} />
      <CircumstancePage isActive={navigationContext.activeAppKey === 'prnacircumstance'} />
    </MainLayout>
  );
}

export default Home;
